// Operator › Deploys (DC-04): deploys into the agency's companies, agency users only (anyone else
// gets the not-found page and no API call; the API answers them 404):
// - `/operator/deploys`: the list and "Stage a deploy";
// - `/operator/deploys/$deployId`: a deploy, its hand-off timeline, failure and bundle, and the
//   approval of a first deploy.
import { createRoute } from "@tanstack/react-router";
import { DeployDetail } from "../features/operator/deploys/deploy-detail";
import { DeploysPage } from "../features/operator/deploys/deploys-page";
import { authedRoute } from "./_authed";
import { OperatorOnly } from "./operator.templates";

export const operatorDeploysRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator/deploys",
  component: function DeploysScreen() {
    const { api } = operatorDeploysRoute.useRouteContext();
    return <OperatorOnly api={api} page={(me) => <DeploysPage api={api} me={me} />} />;
  },
});

export const operatorDeployRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator/deploys/$deployId",
  component: function DeployScreen() {
    const { api } = operatorDeployRoute.useRouteContext();
    const { deployId } = operatorDeployRoute.useParams();
    return (
      <OperatorOnly
        api={api}
        page={(me) => <DeployDetail key={deployId} api={api} me={me} deployId={deployId} />}
      />
    );
  },
});

export const deployOperatorRoutes = [operatorDeploysRoute, operatorDeployRoute] as const;
